import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/entityAuditReport'
import Component from 'components/Reports/OrderAuditReport'

export default createListViewContainer({ actions, selectors: selectors.entityAuditReport })(Component)
